import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function getSearchQueryFromPathname(pathname) {
    if (!pathname.startsWith("/search/")) {
        return "";
    }

    const routeQuery = pathname.slice("/search/".length);

    try {
        return decodeURIComponent(routeQuery);
    } catch (error) {
        return routeQuery;
    }
}

function Search() {
    const location = useLocation();
    const navigate = useNavigate();
    const routeSearchQuery = useMemo(
        () => getSearchQueryFromPathname(location.pathname),
        [location.pathname]
    );
    const [searchQuery, setSearchQuery] = useState(routeSearchQuery);

    useEffect(() => {
        setSearchQuery(routeSearchQuery);
    }, [routeSearchQuery]);

    function handleSubmit(event) {
        event.preventDefault();

        const trimmedQuery = searchQuery.trim();

        navigate(trimmedQuery ? `/search/${encodeURIComponent(trimmedQuery)}` : "/search", {
            replace: true,
        });
    }

    return (
        <form className="search" onSubmit={handleSubmit}>
            <input
                id="SearchQuery"
                name="SearchQuery"
                type="search"
                placeholder="Search Spike's Rewritten Guide"
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
            />
            <button className="search-btn" type="submit">
                <i className="fa fa-search"></i>
            </button>
        </form>
    );
}

export default Search;
